import { TranslationHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import { IntroDetailsResources } from '@types';

export const useCarouselDetails = (): IntroDetailsResources[] => {
	// keep this hook here to update when translations obtained
	const resources = TranslationHelper.getByKey('placeholder.intro.carousel.details');
	const carouselDetails: IntroDetailsResources[] = (resources?.result as IntroDetailsResources[]) || [];

	return carouselDetails;
};
